import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class CleanInvestmentPlanQuestionnaireSessionRequest extends Request<never, void> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `/broad${options?.version ?? '/v1'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/clean_questionnaire_session`
    });
  }

  public execute(): Observable<void> {
    return super.execute().pipe(map((response: HttpResponse<any>) => response.body));
  }
}

export function cleanInvestmentPlanQuestionnaireSession(
  options?: RequestOptions<never>
): CleanInvestmentPlanQuestionnaireSessionRequest {
  return new CleanInvestmentPlanQuestionnaireSessionRequest(options);
}
